import { Dialog, DialogContent } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function SubscriptionAlertModal({ h1, h2, cta1, cta2, isOpen, onClose }) {
  //   const [open, setOpen] = useState(true);
  const navigate = useNavigate();
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogContent className="p-4">
        <h5 className="text-center" style={{ color: "#1B2141" }}>
          {h1}
        </h5>
        <p style={{ color: "#363E5D" }} className="text-center mt-4">
          {h2}
        </p>

        <div className="d-flex justify-content-center gap-3 mt-4">
          <button
            style={{
              background: "white",
              color: "var(--primary-color)",
              height: "40px",
            }}
            className="d-flex align-items-center p-2 px-4 gap-2 rounded-pill border-0"
            onClick={onClose}
          >
            {cta2}
          </button>
          <button
            style={{
              background: "var(--primary-color)",
              color: "white",
              height: "40px",
            }}
            className="d-flex align-items-center p-2 px-4 gap-2 rounded-pill border-0"
            onClick={() => {
              navigate("/clinical/settings?view=Plans%20%26%20Billing");
              onClose();
            }}
          >
            {cta1}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default SubscriptionAlertModal;
